import React, { useContext } from "react";
import { AuthContext } from "../Context/AuthContext";
import { Link } from "react-router-dom";
import ProfileModal from "../container/dashboard/employeemanagement/profile";
import useModal from "../utils/useModal";
import Modal from "react-modal";
import { constant } from "../Constants/constant";

const customStyles = {
  content: {
    top: "40%",
    left: "50%",
    right: "50%",
    bottom: "auto",
    marginRight: "-60%",
    transform: "translate(-50%, -50%)",
    overflow: "scroll",
    width: "1000px",
    height: "100vh",

    // border: "2px solid green",
  },
};

Modal.setAppElement("#root");

export const Header = () => {
  const { user, logout } = useContext(AuthContext);
  const { modalIsOpen, openModal, closeModal } = useModal();

  return (
    <React.Fragment>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="assign cases modal"
      >
        <ProfileModal closeModal={closeModal} user={user.data.user} />
      </Modal>
      <nav className="navbar navbar-inverse navbar-expand-xl navbar-dark">
        <div className="navbar-header d-flex col">
          <a className="navbar-brand" href="/">
            <img
              src="/img/Needle_logo.png"
              width="150px"
              height="50px"
              alt="logo"
            />
          </a>
          <button
            type="button"
            data-target="#navbarCollapse"
            data-toggle="collapse"
            className="navbar-toggle navbar-toggler ml-auto"
          >
            <span className="navbar-toggler-icon"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
        </div>

        <div
          id="navbarCollapse"
          className="collapse navbar-collapse justify-content-start"
        >
          <ul className="nav navbar-nav navbar-right ml-auto">
            <li className="nav-item dropdown">
              <a
                href="#"
                data-toggle="dropdown"
                className="nav-link dropdown-toggle user-action"
                style={{ color: "black" }}
              >
                <img
                  src={`${constant.ImgURL}profile_pictures/uploads/${user.data.user.profile_picture}`}
                  className="rounded-circle "
                  width="40px"
                  height="40px"
                  alt="profile"
                />
                <span className="m-2">{user.data.user.preferred_name}</span>
                <b className="caret"></b>
                <span className="fa fa-angle-down"></span>
              </a>
              <ul className="dropdown-menu">
                <li>
                  <Link
                    onClick={openModal}
                    id="show_full_profile_btn"
                    className="dropdown-item"
                  >
                    <i className="fa fa-user"></i> Profile
                  </Link>
                </li>
                <li>
                  <Link to="/notification" className="dropdown-item">
                    <i className="fa fa-calendar-o"></i> Notifications
                  </Link>
                </li>
                {(user.data.user.roles &&
                  user.data.user.roles.name === "admin") ||
                user.data.user.roles.name === "human resource" ? (
                  <li>
                    <Link
                      to="/dashboard/system-configuration"
                      className="dropdown-item"
                    >
                      <i className="fa fa-cog"></i> Settings
                    </Link>
                  </li>
                ) : null}

                <li>
                  <Link to="/activity-logs" className="dropdown-item">
                    <i className="fa fa-clipboard-list"></i> Activity Log{" "}
                  </Link>
                </li>

                {/* <li className="divider dropdown-divider"></li> */}
                <li>
                  <Link onClick={logout} className="dropdown-item">
                    <i className="fas fa-sign-out-alt"></i> Logout
                  </Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </nav>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/Header.js